import { login ,getuserinfo} from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils";
import router, { resetRouter } from "@/router";

const state = {
  token: getToken(),
  name: "", // 姓名
  avatar: "", // 头像
  telphone: "", // 电话
  position: "", // 职位
  gender: "", // 性别
  birthday: "", // 生日
  lastlogintime: "", // 最后登录时间
  roles: ["admin"], // 角色
  messages: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_TELPHONE: (state, telphone) => {
    state.telphone = telphone;
  },
  SET_BIRTHADY: (state, birthday) => {
    state.birthday = birthday;
  },
  SET_POSITION: (state, position) => {
    state.position = position;
  },
  SET_GENDER: (state, gender) => {
    state.gender = gender;
  },
  SET_LASTLOGINTIME: (state, lastlogintime) => {
    state.lastlogintime = lastlogintime;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_MESSAGES: (state, messages) => {
    state.messages = messages;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ account: username.trim(), passwd: password })
        .then(response => {
          const { data } = response;
          setToken(data.token);
          commit("SET_TOKEN", data.token);
          commit("SET_NAME", data.name || "");
          commit("SET_AVATAR", data.headimg || "");
          commit("SET_TELPHONE", data.telphone || "");
          commit("SET_BIRTHADY", data.birthday || "");
          commit("SET_POSITION", data.position || "");
          commit("SET_GENDER", data.gender || "");
          commit("SET_LASTLOGINTIME", data.lastlogintime || "");
          commit("SET_ROLES", data.roles || ["admin"]);
          window.localStorage.setItem("userInfo", JSON.stringify(data));
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateUserInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      getuserinfo({})
        .then(response => {
          const { data } = response;
          console.log(data)
          setToken(data.token);
          commit("SET_TOKEN", data.token);
          commit("SET_NAME", data.name || "");
          commit("SET_AVATAR", data.headimg || "");
          commit("SET_TELPHONE", data.telphone || "");
          commit("SET_BIRTHADY", data.birthday || "");
          commit("SET_POSITION", data.position || "");
          commit("SET_GENDER", data.gender || "");
          commit("SET_LASTLOGINTIME", data.lastlogintime || "");
          commit("SET_ROLES", data.roles || ["admin"]);
          window.localStorage.setItem("userInfo", JSON.stringify(data));
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      window.localStorage.removeItem("userInfo");
      removeToken();
      resetRouter();
      dispatch("tagsView/delAllViews", null, { root: true });
      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },

  updateMessages({ commit }, messages) {
    commit("SET_MESSAGES", messages);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
